/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_appsync_graphqlEndpoint": "https://3hryly4kwjdddbtulrccrmvffi.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-da37le2rkvcvrb22jewktf2wdm",
    "aws_cloud_logic_custom": [
        {
            "name": "middlewareREST",
            "endpoint": "https://vniz1p2cz7.execute-api.eu-central-1.amazonaws.com/prod",
            "region": "eu-central-1"
        },
        {
            "name": "notificationsApi",
            "endpoint": "https://htos786e30.execute-api.eu-central-1.amazonaws.com/prod",
            "region": "eu-central-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-central-1:125789ba-8dc4-4737-9c9f-6fd221a506f7",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_aRxCFOIdn",
    "aws_user_pools_web_client_id": "1tu1eto4695qrufs220352hel6",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "labouronnect-20200228115848-hostingbucket-prod",
    "aws_content_delivery_bucket_region": "eu-central-1",
    "aws_content_delivery_url": "http://labouronnect-20200228115848-hostingbucket-prod.s3-website.eu-central-1.amazonaws.com",
    "aws_user_files_s3_bucket": "labourtech-case-documents130558-prod",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
